import { useEffect } from "react";
import { analyticsTrackerApi } from "@/react/api/analyticsTrackerApi";
import type { PropertiesType } from "@/react/api/analyticsTrackerApi";
import { usePunditUserContext } from "@circle-react/contexts";
import { usePageViewPropertiesContext } from "./pageViewPropertiesContext";

interface PostViewProperties extends PropertiesType {
  community_id: number;
  community_member_id: number;
  page_view_id?: string;
  post_id: number;
  space_id: number;
}

export const usePostAnalytics = (props: {
  postId?: number;
  spaceId?: number;
  isDisabled?: boolean;
}) => {
  const {
    masqueradingEntity,
    currentCommunity,
    currentCommunityMember,
    isLoading,
  } = usePunditUserContext();
  const { pageViewId } = usePageViewPropertiesContext();

  const postId = props.postId;
  const spaceId = props.spaceId;
  const isDisabled = props.isDisabled;
  const communityId = currentCommunity?.id;
  const communityMemberId = currentCommunityMember?.id;

  useEffect(() => {
    if (!postId || !spaceId || isDisabled || !communityId || !communityMemberId)
      return;
    if (masqueradingEntity || isLoading) return;

    const properties: PostViewProperties = {
      community_id: communityId,
      community_member_id: communityMemberId,
      post_id: postId,
      space_id: spaceId,
      page_view_id: pageViewId ?? "unknown",
    };

    void analyticsTrackerApi.trackPostView(properties);
  }, [
    postId,
    spaceId,
    communityId,
    communityMemberId,
    masqueradingEntity,
    isLoading,
    pageViewId,
    isDisabled,
  ]);
};
